import { ChangeDetectionStrategy, Component, Input, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { OnDestroyHandler } from 'apps/klickdata/src/app/shared/onDestroy-handler/onDestroy-handler';
import * as moment from 'moment';
import { filter, takeUntil } from 'rxjs';
@Component({
    selector: 'app-occasions-dates-manager',
    templateUrl: './occasions-dates-manager.component.html',
    styleUrls: ['./occasions-dates-manager.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OccasionsDatesManagerComponent extends OnDestroyHandler implements OnInit {
    @Input() dateOccasions: FormArray;
    @Input() alwaysOpenControl: FormControl;
    @Input() displayedDates: 'occasions' | 'enrollment' = 'occasions';
    hideOccasionDates = false;
    hideApplicationPeriod = false;
    constructor(private fb: FormBuilder, private cd: ChangeDetectorRef) {
        super();
    }

    ngOnInit(): void {
        if (this.alwaysOpenControl) {
            this.alwaysOpenControl.valueChanges.pipe(takeUntil(this.destroy)).subscribe((value) => {
                if (value) {
                    this.clearAllOccasionsDates();
                    this.hideOccasionDates = true;
                    this.keepFirstDateOnly();
                } else {
                    this.hideOccasionDates = false;
                }
                this.dateOccasions.markAsDirty();
                this.cd.markForCheck();
            });
        }
        this.dateOccasions.valueChanges.pipe(takeUntil(this.destroy)).subscribe((dates) => {
            this.cd.markForCheck();
        });
    }
    keepFirstDateOnly(): void {
        while (this.dateOccasions.length > 1) {
            this.dateOccasions.removeAt(1);
        }
        this.dateOccasions.markAsDirty();
    }
    private clearAllOccasionsDates(): void {
        this.dateOccasions.controls.forEach((control: FormGroup) => {
            control.patchValue({
                start_date: null,
                end_date: null,
            });
        });
        this.dateOccasions.markAsDirty();
        this.cd.markForCheck();
    }
    addDate() {
        this.dateOccasions.push(
            this.fb.group({
                id: [null],
                start_date: [],
                end_date: [],
                application_start_date: [],
                application_end_date: [],
            })
        );
        this.dateOccasions.markAsDirty();
        this.cd.markForCheck();
    }

    removeDate(i: number) {
        this.dateOccasions.removeAt(i);
        this.dateOccasions.markAsDirty();
        this.cd.markForCheck();
    }
    get occasionDatesErrors(): { [key: string]: string[] } | null {
        return this.dateOccasions?.errors?.occasionDates ?? null;
    }
}
